"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPlastics = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const Article_1 = require("../../Article");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
class SmartPlastics extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'SmartPlastics';
    }
    static fromScratch() {
        return new SmartPlastics({ ArticleType: 'zubehoer', EntityId: echain_shared_oo_1.UUIDGenerator.new() });
    }
    static fromModel(model) {
        const smartPlastics = SmartPlastics.fromScratch();
        Object.assign(smartPlastics.model, model);
        Object.assign(model, smartPlastics.model);
        smartPlastics.model = model;
        return smartPlastics;
    }
    static fromJson(args) {
        const smartPlastics = SmartPlastics.fromScratch();
        smartPlastics.fromJson(args);
        return smartPlastics;
    }
    clone() {
        const model = (0, echain_shared_ts_utils_1.clonePrimitive)(this.toModel());
        return SmartPlastics.fromModel(model);
    }
    duplicate() {
        return SmartPlastics.fromModel(this.toModel());
    }
}
exports.SmartPlastics = SmartPlastics;
//# sourceMappingURL=SmartPlastics.js.map